// features/council/useCaseTarget.ts — resolve a case to display headline + nav target.
import { usePosts, useUser } from '@/hooks';
import type { CaseRecord } from '@/core/models/case';

export interface CaseTarget {
  headline: string;
  href: string | null;
  sub: string[];
}

export function useCaseTarget(c: CaseRecord): CaseTarget {
  const { posts } = usePosts();
  // useUser must be called unconditionally (rules of hooks); pass null for post cases.
  const accountUser = useUser(c.kind === 'account' ? c.accountId ?? null : null);

  const sub = [c.team, `reported by ${c.reporter}`, `weight: ${c.reportWeight}`];

  if (c.kind === 'account') {
    if (accountUser) {
      const handle = accountUser.handle.replace(/^@/, '');
      return {
        headline: `${accountUser.name} ${accountUser.handle}, account`,
        href: `/profile/${handle}`,
        sub,
      };
    }
    return { headline: `${c.accountId ?? 'Unknown'}, account`, href: null, sub };
  }

  const post = posts.find((p) => p.id === c.postId);
  return {
    headline: post ? `${post.name} ${post.handle}` : `Reported post ${c.postId ?? ''}`,
    href: c.postId ? `/post/${c.postId}` : null,
    sub,
  };
}
